export function getWelcomeUsers(state) {
  return state.welcomes
}